<!--
    Summary:
        hkml.exhibition.web - media-center-page
    ChangeLog:
        wangn on 2020/11/29 added
-->
<template>
  <div class="v-media-center-page" title="media-center-page">
    <div class="header">
      <h2>{{notice.Abstract}}</h2>
      <h5>{{notice.PublishTime}}</h5>
    </div>
    <div class="content">
      <div v-if="!isEng" v-html="notice.Content"></div>
      <div v-else v-html="notice.EnglishContent"></div>
    </div>
  </div>
</template>

<script>
  import {GetNotice} from '../../../service/searchreport'

  export default {
    name: "media-center-page",
    data() {
      return {
        id: this.$route.query.id,
        notice: {
          Abstract: '',
          Content: '',
          EnglishContent: ''
        }
      }
    },
    mounted() {
      this.getData();
    },
    computed: {
      isEng: function () {
        return this.$i18n.locale == 'en-US';
      }
    },
    methods: {
      async getData() {
        //tip,category, startDate, endDate, pageIndex, pageSize
        let resp = await GetNotice(this.id);

        let notice = resp;
        notice.PublishTime = this.formatDate(notice.PublishTime);
        //data.FullCover = process.env.BASE_URL + data.Cover;

        this.notice = notice;
      },
      formatDate(dateStr) {
        if (!dateStr) return dateStr;
        try {
          let date = new Date(dateStr);
          let day = date.getDate(), month = date.getMonth() + 1, year = date.getFullYear();

          if (day < 10) day = '0' + day;
          if (month < 10) day = '0' + month;
          return day + '-' + month + '-' + year;
        } catch (ex) {
        }
        return dateStr;
      },
    },
  }
</script>
<style>
  .v-media-center-page p{
    font-size: 1.70vw;
    line-height: 3.13vw;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0;
    color: #000000;

    margin-bottom: 2vw;
  }
</style>
<style scoped lang="scss">
  .v-media-center-page {
    padding: 2vw 15vw 3vw;
    text-align: left;

    .header {
      text-align: center;
      margin-bottom: 2vw;
      position: relative;

      h2 {
        font-weight: bold;
        color: #273a63;
        font-size: 2.66vw;
      }

      h5{
        font-size: 1.5vw;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/news/media-center/media-center-page.vue